import { Navigate } from "react-router-dom";
import { PageLoadingState } from "../components/layout/PageLoadingState";
import { useSoulAccess } from "../data/providers/SoulProvider";

type PermissionRouteProps = {
  path: string;
  children: React.ReactElement;
};

const PermissionRoute = ({ path, children }: PermissionRouteProps) => {
  const { soul, loading, canAccessPath, defaultAuthorizedPath } = useSoulAccess();

  if (loading) {
    return <PageLoadingState label="Cargando tus permisos" />;
  }

  if (!soul) {
    return <Navigate to="/" replace />;
  }

  if (canAccessPath(path)) {
    return children;
  }

  if (defaultAuthorizedPath && defaultAuthorizedPath !== path) {
    return <Navigate to={defaultAuthorizedPath} replace />;
  }

  return <Navigate to="/dashboard/no-access" replace />;
};

export default PermissionRoute;
